export default {
  changeShowLoginBox(state, bool) {
    state.showLoginBox = bool;
  },
  /**保存更改用户信息 */
  setUserInfo(state, userInfo) {
    state.userInfo = userInfo;
  },
  changeIsLogin(state, bool) {
    state.isLogin = bool;
  },

  setIntroduceInfo(state, introduceInfo) {
    state.introduceInfo = introduceInfo;
  },
  /**修改省级门户信息 */
  setProvinceName(state, data) {
    state.provinceName = data;
  }
};